import React from "react";
import "../BusinessBanner.css"; // Import CSS file

const BusinessBanner = ({ businessName, businessType }) => {
  return (
    <div className="business-banner">
      <div className="business-details">
        <h1 className="business-name">
          {businessName.toLocaleUpperCase("TR-tr")}
        </h1>
        <p className="business-type">{businessType}</p>
      </div>
      <div className="cart-icon">
        <i className="fa fa-shopping-cart"></i> {/* FontAwesome cart icon */}
      </div>
    </div>
  );
};

export default BusinessBanner;
